<template>
	<div class="conten">
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true">
				<el-form-item>
					<el-input v-model="secah.name" placeholder="请输入分类名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button @click='secahClick'>搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click='add'>新增</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="danger" @click='delAll'>批量删除</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<div>
			<el-table :data="tableData" style="width: 100%" border @selection-change="handleSelectionChange">
				<el-table-column fixed="left" type="selection" width="35">
				</el-table-column>
				<el-table-column prop="id" label="ID"  align="center">					
				</el-table-column>
				<el-table-column prop="name" label="分类名称"  align="center">
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="180" align="center">
					<template slot-scope="scope">
						<el-button size="mini" @click="edit(scope.row)">编辑</el-button>
						<el-button size="mini" type="danger" @click="del(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="page">
			<el-pagination
			      @size-change="handleSizeChange"
			      @current-change="handleCurrentChange"
				  :current-page.sync="page.pageNum"
			      :page-sizes="[10, 20, 50, 100]"
			      :page-size="10"
			      layout="total, sizes, prev, pager, next, jumper"
			      :total="page.total">
			    </el-pagination>
		</div>
		<el-dialog :title="isAdd?'新增':'修改'" :visible.sync="dialogVisible" :modal-append-to-body='false' width="600px">
			<el-form :model="form">
				<el-form-item label="标题" label-width='100px'>
					<el-input v-model="form.name" autocomplete="off" placeholder="请输入标题"></el-input>
				</el-form-item>
				

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				selectTableData: [],
				tableData: [{
						id: 1,
						name: '分类名称'
					},
					{
						id: 2,
						name: '分类名称'
					}
				],
				page:{
					pageNum:1,
					pageSize:10,
					total:100				
				},
				dialogVisible: false,
				isAdd: true,
				secah:{
					name:""
				},
				form: {
					name: ""
				},

			}
		},
		methods: {
			//搜索
			secahClick(){},
			//新增
			add() {
				this.dialogVisible = true
				this.isAdd = true
			},
			//批量删除
			delAll() {
				var ids = []

				if (this.selectTableData.length == 0) {
					this.$message('请选择需要删除项');
					return false
				}
				for (var i = 0; i < this.selectTableData.length; i++) {
					ids.push(this.selectTableData[i].id)
				}
				console.log(ids)
			},
			//删除
			del(row) {
				console.log(row);
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//修改
			edit(row) {
				console.log(row);
				this.dialogVisible = true
				this.isAdd = false
			},
			//勾选数据
			handleSelectionChange(arr) {
				this.selectTableData = arr
			},
			//选择分页条数
			handleSizeChange(e){				
				this.page.pageNum=1
				this.page.pageSize=e
				console.log(this.page)
			},
			//页码
			handleCurrentChange(e){				
				this.page.pageNum=e
				console.log(this.page)
			},
		},


	}
</script>

<style scoped lang='scss'>	
	.page{
		padding: 20px 0;
	}	
</style>
